import { Link, NavLink } from "react-router-dom";
import SectorPicker from "./SectorPicker";
import { useBrand } from "../lib/brand";

const navLink = ({ isActive }) =>
    `text-sm tracking-tight transition-colors duration-200 ${
        isActive ? "text-slate-900 font-semibold" : "text-slate-500 hover:text-slate-900"
    }`;

export default function Header() {
    const brand = useBrand();
    const isCierge = brand.mode === "cierge";
    return (
        <header
            className="sticky top-0 z-40 bg-white/90 backdrop-blur-xl border-b border-slate-200"
            data-testid="site-header"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between gap-6">
                <Link
                    to="/"
                    className="flex items-center gap-3 min-w-0"
                    data-testid="brand-home-link"
                >
                    <span className="font-mono text-[11px] tracking-[0.22em] uppercase text-slate-500 hidden sm:inline">
                        Responsible Technology Lab
                    </span>
                    <span className="hidden md:inline-block w-px h-5 bg-slate-200" />
                    <span className="font-semibold tracking-tight text-slate-900">
                        {brand.wordmark}
                    </span>
                </Link>
                <div className="flex items-center gap-6">
                    {!isCierge && (
                        <div className="hidden lg:block">
                            <SectorPicker />
                        </div>
                    )}
                    <nav className="flex items-center gap-6">
                        <NavLink to="/" end className={navLink} data-testid="nav-home">
                            Lab
                        </NavLink>
                        {isCierge && (
                            <NavLink
                                to="/responsible-technology"
                                className={navLink}
                                data-testid="nav-responsible-technology"
                            >
                                Governed action
                            </NavLink>
                        )}
                        {brand.show_tech_lab && (
                            <NavLink to="/tech-lab" className={navLink} data-testid="nav-tech-lab">
                                Tech Lab
                            </NavLink>
                        )}
                        <NavLink to="/receipts" className={navLink} data-testid="nav-receipts">
                            Receipts
                        </NavLink>
                    </nav>
                </div>
            </div>
            {!isCierge && (
                <div className="lg:hidden border-t border-slate-100 px-6 py-2 flex items-center justify-end">
                    <SectorPicker compact />
                </div>
            )}
        </header>
    );
}
